import { render, staticRenderFns } from "./DxpDescriptionImageCardCustom.vue?vue&type=template&id=2825a1bc&scoped=true&"
import script from "./DxpDescriptionImageCardCustom.vue?vue&type=script&lang=js&"
export * from "./DxpDescriptionImageCardCustom.vue?vue&type=script&lang=js&"
import style0 from "./DxpDescriptionImageCardCustom.vue?vue&type=style&index=0&id=2825a1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825a1bc",
  null
  
)

export default component.exports